var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 552.11175 96.639204",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.0787 14.0713v57.2593h56.1391v-57.2593h19.6226v53.8604q0 9.67755-4.3267 13.1763-4.3242 3.50385-16.6558 3.5039h-53.497q-12.25559 0-16.6187-3.5039-4.3659-3.504-4.3662-13.1763v-53.8604z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.88579 26.6856v57.9263h-19.7002v-57.9263h-38.8423v-12.6143h97.5483v12.6143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.39459 26.6856v57.9263h-19.6973v-57.9263h-38.84279v-12.6143h97.545v12.6143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.0625 30.7549q0-9.60855 4.32619-13.1469 4.31985-3.537 16.6563-3.5367h62.3046q12.3384 0 16.6622 3.5367 4.3197 3.539 4.3261 13.1469v37.1768q0 9.67755-4.3261 13.1763-4.3302 3.50385-16.6622 3.5039h-62.3046q-12.3297 0-16.6563-3.5039-4.32855-3.504-4.32619-13.1763zm19.70319 40.5757h64.9492v-44.645h-64.9492z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.4673 28.4976v-8.2661c0-8.9092-6.5942-16.4614-15.7412-19.1592v27.4253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 68.7876v7.6172c0 8.7129 6.313 16.1211 15.1446 18.9668v-26.584z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.148 66.6553-38.5098-38.1577h19.9317v-28.4976h-34.44c-12.7749 0-23.1299 9.0606-23.1299 20.2315v43.8096l33.7168-33.4112 38.5098 38.1577h-19.9287v27.8516h35.043c12.7744 0 23.1264-9.0644 23.1264-20.2344v-43.7544z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.6382 28.4976 38.5098 38.1577 34.3193-34.0049v-4.1528h-15.7412v-27.4253a26.15329 26.15329 0 0 0 -7.3852-1.0723h-29.771v28.4976z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m72.2266 68.7876-38.5098-38.1577-33.7168 33.4112v4.7465h15.1446v26.584a26.05412 26.05412 0 0 0 7.9853 1.2676h29.168v-27.8516z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.7bfa7111bf4e8aad4af6e076e65075dd.svg";
export { ForwardRef as ReactComponent };